export const en = {
  open: 'Open',
  close: 'Close',
  share: 'Share on',
  languages: 'Languages',
  footer: {
    copyright: '© 2018 Codeurs, All rights reserved.'
  },
  contact: {
    name: 'Name',
    email: 'Email',
    question: 'Message',
    submit: 'Submit',
    thanks: 'Thanks for your message'
  },
  error404: {
    title: 'Page not found',
    text: `The page you are looking for might have been removed, had its name 
			changed, or is temporarily unavailable.`,
    btn: 'Back to home'
  },
  cookies: {
    text: 'This website uses cookies to improve your browsing experience.',
    accept: 'Accept cookies',
    decline: 'Decline cookies'
  },
  header: {
    top: {
      text: 'Official information and services',
      link: 'https://www.belgium.be/en'
    }
  },
  previewlink: {readmore: 'Read more'},

  contentpage: {
    related_publication: 'Related publication',
    related_articles: 'Related articles'
  },
  library: {
    all_years: 'All years',
    filter: {
      type: 'Filter by type:',
      category: 'Filter by level',
      themes: 'Filter by theme'
    },
    published: 'Published on',
    search: 'Search in ',
    select_year: 'Select a year',
    loadmore: 'Load more articles'
  },
  sidebar: {related: 'Related pages'},
  search: {
    title: 'Search results',
    noresult: 'No search results were found'
  },
  sharepage: 'Share page',
  sitemap: {
    home: 'Homepage',
    home2050: 'Homepage 2050',
    homecbam: 'Homepage CBAM'
  },
  newsletter: {
    btn: 'Newsletter',
    label: 'Go to newsletter',
    submit: 'Subscribe to the newsletter',
    error:
      'An error occurred while submitting the form. Please try again later.'
  }
}
